module.exports = __webpack_public_path__ + "assets/koenigs-apo-logo.ed0be9d7.jpeg";